/**
 * viewerTableSkinAssets.ts — Resolves the Phaser table-surface texture key and
 * asset path for the current viewer's table skin. Mirrors viewerTileSkinAssets.
 *
 * DURABLE Cosmetics infrastructure. A table skin changes ONLY which background
 * image the felt binds to — it never touches board dimensions, BOARD_UNIT_SIZE,
 * the grid, coordinates, snapping, or any gameplay geometry (see Board.drawFelt
 * and sceneLayout.ts — those keep computing the identical tableSize formula).
 */
import type { ViewerTableSkin } from './viewerCosmetics';

/** Phaser texture-cache key for a table skin's surface art. */
export function getViewerTableTextureKey(skin: ViewerTableSkin): string {
  return `table-skin-${skin}`;
}

/** Public asset path for a table skin's full square artwork. */
export function getViewerTableAssetPath(skin: ViewerTableSkin): string {
  return `/Assets/game/tables/${skin}.png`;
}
